/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { checkVersion } from '../fn/collector/check-version';
import { CheckVersion$Params } from '../fn/collector/check-version';
import { insertColReceiveImporterErrors } from '../fn/collector/insert-col-receive-importer-errors';
import { InsertColReceiveImporterErrors$Params } from '../fn/collector/insert-col-receive-importer-errors';
import { insertColTransactionStoreErrors } from '../fn/collector/insert-col-transaction-store-errors';
import { InsertColTransactionStoreErrors$Params } from '../fn/collector/insert-col-transaction-store-errors';
import { login1 } from '../fn/collector/login-1';
import { Login1$Params } from '../fn/collector/login-1';
import { shutdown } from '../fn/collector/shutdown';
import { Shutdown$Params } from '../fn/collector/shutdown';
import { startup } from '../fn/collector/startup';
import { Startup$Params } from '../fn/collector/startup';
import { ValidationError } from '../models/validation-error';

@Injectable({ providedIn: 'root' })
export class CollectorService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `startup()` */
  static readonly StartupPath = '/api/public/collector/startup';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `startup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  startup$Response(params: Startup$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return startup(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `startup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  startup(params: Startup$Params, context?: HttpContext): Observable<string> {
    return this.startup$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `shutdown()` */
  static readonly ShutdownPath = '/api/public/collector/shutdown';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shutdown()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shutdown$Response(params: Shutdown$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return shutdown(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shutdown$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shutdown(params: Shutdown$Params, context?: HttpContext): Observable<string> {
    return this.shutdown$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `login1()` */
  static readonly Login1Path = '/api/public/collector/login';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `login1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  login1$Response(params: Login1$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return login1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `login1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  login1(params: Login1$Params, context?: HttpContext): Observable<string> {
    return this.login1$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `insertColTransactionStoreErrors()` */
  static readonly InsertColTransactionStoreErrorsPath = '/api/collector/transaction_errors';

  /**
   * Write given DataCollector transaction errors in cloud db.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `insertColTransactionStoreErrors()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  insertColTransactionStoreErrors$Response(params?: InsertColTransactionStoreErrors$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ValidationError>>> {
    return insertColTransactionStoreErrors(this.http, this.rootUrl, params, context);
  }

  /**
   * Write given DataCollector transaction errors in cloud db.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `insertColTransactionStoreErrors$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  insertColTransactionStoreErrors(params?: InsertColTransactionStoreErrors$Params, context?: HttpContext): Observable<Array<ValidationError>> {
    return this.insertColTransactionStoreErrors$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ValidationError>>): Array<ValidationError> => r.body)
    );
  }

  /** Path part for operation `insertColReceiveImporterErrors()` */
  static readonly InsertColReceiveImporterErrorsPath = '/api/collector/receiver_errors';

  /**
   * Write given DataCollector receiver importer errors in cloud db.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `insertColReceiveImporterErrors()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  insertColReceiveImporterErrors$Response(params?: InsertColReceiveImporterErrors$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ValidationError>>> {
    return insertColReceiveImporterErrors(this.http, this.rootUrl, params, context);
  }

  /**
   * Write given DataCollector receiver importer errors in cloud db.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `insertColReceiveImporterErrors$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  insertColReceiveImporterErrors(params?: InsertColReceiveImporterErrors$Params, context?: HttpContext): Observable<Array<ValidationError>> {
    return this.insertColReceiveImporterErrors$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ValidationError>>): Array<ValidationError> => r.body)
    );
  }

  /** Path part for operation `checkVersion()` */
  static readonly CheckVersionPath = '/api/collector/version';

  /**
   * Check if the given DataCollector version is the most recent. If not, returns the zip file.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `checkVersion()` instead.
   *
   * This method doesn't expect any request body.
   */
  checkVersion$Response(params: CheckVersion$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return checkVersion(this.http, this.rootUrl, params, context);
  }

  /**
   * Check if the given DataCollector version is the most recent. If not, returns the zip file.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `checkVersion$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  checkVersion(params: CheckVersion$Params, context?: HttpContext): Observable<Blob> {
    return this.checkVersion$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
